module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  status: 'Status',
  actions: 'Actions',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  search: 'Search',
  export: 'Export',
  from: 'From',
  to: 'To',
  action: 'Action',
  allNone: 'All/None',
  first: 'First',
  last: 'Last',
  model: 'Model',
  default: 'Default',
  registeredOn: 'Registered on',
  lastModifiedOn: 'Last modified on',
  createdOn: 'Created on',
  modifiedOn: 'Modified on',
  cachedOn: 'Cached on',
  cacheType: 'Cache type',
  hour: 'Hour',
  minute: 'Minute',
  mandatory: 'Mandatory',
  markdownPreview: 'Markdown preview',
  response: 'Response',
  notifications: 'Notifications',
  text: 'Text',
  themes: 'Themes',
  details: 'Details',
  advanced: 'Advanced',
  download: 'Download',
  downloadAsFile: 'Download as a file',
  instance: 'Instance',
  backendversion: 'Backend',
  arguments: 'Arguments',
  parameters: 'Parameters',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  changePassword: 'Change password',
  system: 'System',
  created: 'Created',
  updated: 'Updated',
  cancellation: 'Cancel',
  captcha: 'Captcha',
  print: 'Print',
  register: 'Register',
  number: 'No',
  mode: 'Mode',
  dark: 'Dark',
  fontSizes: 'Font Sizes',
  theme: 'Themes',
  none: 'None',
  successful: 'Successful',
  open: 'Open',
  failed: 'Failed',
  activeOnly: 'Active Only',
  keyType: 'Key Type',
  payload: 'Payload',
  privateKey: 'Private Key',
  publicKey: 'Public Key',
  signatureAlgorithm: 'Signature Algorithm',
  url: 'URL',
  maxPoolSize: 'Max Pool Size',
  host: 'Host',
  port: 'Port',
  sid: 'SID',
  token: 'Token',
  apiToken: 'API Token',
  apiVersion: 'API Version',
  appId: 'APP ID',
  aud: 'AUD',
  id: 'ID',
  maxProcessingDurationInMSec: 'Max Processing Duration in MSec',
  maxProcessingDuration: 'Max Processing Duration',
  process: 'Process',
  triggerCondition: 'Trigger Condition',
  seconds: 'Seconds',
  minutes: 'Minutes',
  minutesInterval: 'Minutes Interval',
  hours: 'Hours',
  hoursInterval: 'Hours Interval',
  iban: 'IBAN',
  dayOfMonth: 'Day Of Month',
  month: 'Month',
  dayOfWeek: 'Day Of Week',
  method: 'Method',
  maxRequestSize: 'Max Request Size',
  frontEnd: 'Front end',
  searchByName: 'Search By Name',
  finishedOn: 'Finished on',
  startedOn: 'Started on',
  instanceId: 'Instance ID',
  eventId: 'Event ID',
  threadId: 'Thread ID',
  date: 'Date',
  clientId: 'Client ID',
  connectorId: 'Connector ID',
  authorization: 'Authorization',
  clientSecret: 'Client Secret',
  selectProcessFirst: 'Select process first',
  event: 'Event',
  exceptionMessage: 'Exception Message',
  exceptionName: 'Exception Name',
  exceptionStackTrace: 'Exception Stack Trace',
  stepId: 'Step ID',
  maxSimultaneousExecutions: 'Max Simultaneous Executions',
  saveProcessToEditSteps: 'Save Process To Edit Steps',
  defaultStepsName: 'Steps Name',
  properties: 'Properties',
  propertiesSmall: 'properties',
  stepProperties: 'Step Properties',
  enabled: 'Step enabled',
  enabledGeneric: 'Enabled',
  query: 'Query',
  targetObject: 'Target Object',
  credential: 'Credential',
  recordName: 'Record Name',
  triggerId: 'Trigger ID',
  type: 'Type',
  processingStartOn: 'Processing started on',
  showCache: 'Cache',
  list: 'List',
  array: 'Array',
  variable: 'Variable',
  json: 'JSON',
  async: 'Asynchronous execution',
  input: 'Input',
  output: 'Output',
  js: 'JavaScript',
  switch: 'Switch',
  collectionName: 'Collection Name',
  queryUpdate: 'Query Update',
  mailTemplate: 'Mail Template',
  variables: 'Variables',
  subject: 'Subject',
  restResponseCode: 'REST response code target object',
  targetPort: 'Target Port',
  targetUrl: 'Target URL',
  timeout: 'Timeout in MSec',
  body: 'Body',
  bodyScript: 'Body Script',
  headers: 'Headers',
  headersTargetObject: 'Headers target object',
  queryParams: 'Query Params',
  channelId: 'Channel ID',
  message: 'Message',
  enterToSendHint: 'Enter to send, Shift+Enter for new line',
  logsTtlInMSec: 'Time-to-live for other logs',
  stepName: 'Step Name',
  copy: 'Copy',
  copyIdToClipboard: 'Copy ID to Clipboard',
  copyright: 'Copyright',
  steps: 'Steps',
  filter: 'Filter',
  roles: 'Roles',
  tags: 'Tags',
  tag: 'Tag',
  step: 'Step',
  childStep: 'Child Step',
  permissions: 'Permissions',
  code: 'Code',
  assignable: 'Assignable',
  yes: 'Yes',
  no: 'No',
  textTemplate: 'Text Template',
  en: 'English',
  de: 'German',
  ar: 'Arabic',
  language: 'Language',
  connectionTimeout: 'Connection Timeout',
  writeTimeout: 'Write Timeout',
  template: 'Template',
  grant_type: 'Grant type',
  refresh_token: 'Refresh token',
  frontendUrl: 'Frontend URL',
  maxTriggerHttpThreads: 'Max Trigger Http Threads',
  maxTriggerHttpProcessingInMSec: 'Max Rest Trigger Processing Duration',
  maxProcessingThreads: 'Max Processing Threads',
  permissionType: 'Permission Type',
  unit: 'Unit',
  changeableTimeout: 'Timeout',
  secondsInterval: 'Seconds Interval',
  account: 'Account',
  yourAccount: 'Your Account',
  setPassword: 'Set Password',
  confirmPassword: 'Confirm Password',
  baseUrlRest: 'Base URL Rest',
  stepType: 'Step Type',
  gdpr: 'GDPR Relevant',
  history: 'History',
  notSet: 'Not set',
  defaultLocale: 'Default Locale',
  global: 'Global',
  local: 'Local',
  est: 'Trace',
  addProcessName: 'Add Process Name',
  visualId: 'Visual ID',
  validation: 'Validation',
  permission: 'Permission',
  exist: 'Exist',
  missingParams: 'Missing Required Resources',
  fileLoaded: 'File Loaded',
  scriptEngine: 'Script Engine',
  dataType: 'Data Type',
  ruleType: 'Rule Type',
  fields: 'Fields',
  fieldName: 'Field Name',
  required: 'Required',
  rules: 'Rules',
  field: 'Field',
  rule: 'Rule',
  validationRules: 'Validation Rules',
  logServerUrl: 'Log Server URL',
  logs: 'Logs',
  apiKey: 'API Key',
  listOfCodes: 'List of HTTP codes',
  logsServer: 'Log Server',
  nextLogStep: 'Next Log Step',
  previousLogStep: 'Previous Log Step',
  fetchLastEventLogs: 'Fetch Last Event Logs',
  debug: 'Debug',
  processSettingName: 'Setting',
  UPLOAD: 'Upload',
  DOWNLOAD: 'Download',
  descriptions: 'Descriptions',
  loadDirection: 'Load Direction',
  encrypt: 'Encrypt',
  restResponseContentTargetObject: 'REST response content target object',
  restResponseHeadersTargetObject: 'REST response headers target object',
  enableStepLog: 'Logging',
  urlForAdmin: 'Healthcheck URL for admin',
  urlForProcessingService: 'Healthcheck URL for the processing service',
  searchByModuleName: 'Search by Module Name',
  description: 'Description',
  basicAccessAuthentication: 'Allow Basic Authentication',
  isLogFaultyRequest: 'Log Faulty Requests',
  upDownload: 'Up/Download',
  remoteId: 'Remote ID',
  exception: 'Exception',
  className: 'Class Name',
  checksum: 'Checksum',
  stepTypes: 'Step Types',
  plugin: 'Plugin',
  selectPlugin: 'Select Plugin First',
  processLogs: 'Process logs',
  openProcessLogs: 'Logs',
  accessKeyId: 'Access Key Id',
  region: 'Region',
  s3Bucket: 'S3 Bucket',
  secretKey: 'Secret Key',
  content: 'Content',
  key: 'Key',
  path: 'Path',
  oldPath: 'Old Path',
  newPath: 'New Path',
  pageNumber: 'Page Number',
  events: 'Events',
  backEnd: 'Back end',
  isCacheStepLogsEnabled: 'Cache storage',
  isStepLogsEnabled: 'Logging',
  enableCacheLog: 'Cache storage',
  tos: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  passphrase: 'Passphrase',
  queryConsole: 'Query Console',
  console: 'Console',
  affectedRows: 'Affected Rows',
  success: 'Success',
  respondSent: 'Respond sent',
  resultDetails: 'Result Details',
  engine: 'Engine',
  isBodyScript: 'Body Script',
  groovy: 'Groovy',
  last15MinutesCount: 'Last 15 minutes',
  last24HoursCount: 'Last 24 hours',
  last60MinutesCount: 'Last 60 minutes',
  todayCount: 'Today',
  executions: 'Executions',
  eventStates: 'Event states',
  childEventIdPath: 'Child event ID target object',
  folder: 'Folder',
  sizeInBytes: 'Size In Bytes',
  readType: 'Read Type',
  maxResults: 'Max Results',
  recipient: 'Recipient',
  sender: 'Sender',
  emailId: 'Email Id',
  locale: 'Locale',
  heartbeat: 'Heartbeat',
  user: 'User',
  overview: 'Overview',
  review: 'Review',
  view: 'View',
  title: 'Title',
  rating: 'Rating',
  reviews: 'Reviews',
  submitReview: 'Submit Review',
  metricServerUrl: 'Metric Server URL',
  visualisationServerUrl: 'Visualisation Server URL',
  metricServer: 'Metric Server',
  visualisationServer: 'Visualisation Server',
  internalJobs: 'Internal Jobs',
  started: 'Started',
  hideChildren: 'Hide children',
  showChildren: 'Show children',
  diagrams: 'Diagrams',
  genericSubType: 'Member type',
  userId: 'User ID',
  filters: 'Filters',
  source: 'Source',
  sourceImage: 'Source Image',
  sources: 'Sources',
  attachments: 'Attachments',
  showAttachments: 'Show attachments',
  showByHour: 'Show By Hour',
  contentType: 'Content type',
  includeHeaders: 'Include headers in output',
  openProcessEvents: 'Events',
  validations: 'Validations',
  allowQueryConsole: 'Allow usage of Query Console',
  stats: 'Statistics',
  available: 'Available',
  used: 'Used',
  processing: 'Processing',
  http: 'Http',
  threadStatistics: 'Thread statistics',
  lastUpdateHeartbeat: 'Last update / Heartbeat',
  delimiter: 'Delimiter',
  qualifier: 'Text Qualifier',
  quantity: 'Quantity',
  customDelimiter: 'Custom delimiter',
  cc: 'CC',
  bcc: 'BCC',
  signInAgreement: 'By signing in, you agree to the',
  singleResult: 'Single result',
  comment: 'Comment',
  debugLogData: 'Debug log data',
  debugLog: 'Debug',
  width: 'Width',
  height: 'Height',
  positionX: 'Position X',
  positionY: 'Position Y',
  format: 'Format',
  exampleVariables: 'Variable Configuration',
  all: 'All',
  allRightsReserved: 'All rights reserved',
  profile: 'Profile',
  visuals: 'Visuals',
  general: 'General',
  light: 'Light',
  lineExtensionAmount: 'Line Extension Amount',
  colors: 'Colors',
  overallSimultaneousExecutions: 'Overall max simultaneous exec.',
  simultaneousExecutionsPerInstance: 'Max. simultaneous exec. per instance',
  processId: 'Process ID',
  showGraph: 'Show graph',
  command: 'Command',
  commands: 'Commands',
  resultCode: 'Result code',
  resultErrors: 'Result errors',
  forgotYourPassword: 'Forgot your password?',
  try: 'Try',
  catch: 'Catch',
  exceptions: 'Exceptions',
  optionalQueryName: 'Query name',
  optionalBatchName: 'Batch name',
  topic: 'Topic',
  groupId: 'Group ID',
  bootstrapServers: 'Bootstrap servers',
  groupNodes: 'Group nodes',
  messageKey: 'Message key',
  service: 'Service',
  count: 'Count',
  daily: 'daily',
  monthly: 'monthly',
  year: 'Year',
  yearly: 'yearly',
  healthcheckURL: 'Healthcheck URL',
  failures: 'Failures',
  favorite: 'Favorite',
  firstOccurrence: 'First occurrence',
  lastOccurrence: 'Last occurrence',
  counter: 'Counter',
  processName: 'Process name',
  display: 'Display',
  showCreatedOn: 'Show Created On',
  hostUrl: 'Host URL',
  installerId: 'Installer ID',
  softwareHouseId: 'Software House ID',
  reportType: 'Report type',
  accepted: 'Accepted',
  requestId: 'Request ID',
  terminalId: 'Terminal ID',
  transaction: 'Transaction',
  amount: 'Amount',
  amountCashback: 'Amount cashback',
  amountPreAuthorisedTotal: 'Amount pre-authorised total',
  authCode: 'Auth code',
  cardholderNotPresent: 'Cardholder not present',
  currency: 'Currency',
  transactionType: 'Transaction type',
  uri: 'URI',
  queue: 'Queue',
  deliveryMode: 'Delivery mode',
  priority: 'Priority',
  timeToLive: 'Time to live',
  destinationType: 'Destination type',
  destinationName: 'Destination name',
  copyPaste: 'Copy & paste',
  finally: 'Finally',
  receivingInstanceId: 'Receiving instance ID',
  blue: 'Blue',
  instanceIdlong: 'Executing instance ID',
  jwt: 'JWT',
  merchantUrl: 'Merchant URL',
  accessToken: 'Access token',
  crossReference: 'Cross reference',
  cv2: 'CV2',
  merchantTransactionId: 'Merchant transaction ID',
  customerId: 'Customer ID',
  currencyCode: 'Currency code',
  newTransaction: 'New transaction',
  orderDescription: 'Order description',
  orderId: 'Order ID',
  shippingDetails: 'Shipping details',
  userAddress1: 'Address 1',
  userAddress2: 'Address 2',
  userAddress3: 'Address 3',
  userAddress4: 'Address 4',
  userAddress: 'Address',
  userCity: 'City',
  userCountry: 'Country',
  userEmail: 'Email',
  userCountryCode: 'Country code',
  userPostcode: 'Postcode',
  userState: 'State',
  transactionSource: 'Transaction source',
  userAgent: 'User agent',
  userEmailAddress: 'Email address',
  userIpAddress: 'IP address',
  userPhoneNumber: 'Phone number',
  additionalStreetName: 'Additional Street Name',
  address: 'Address',
  waitPreExecute: 'Wait for pre-execute',
  webHookUrl: 'Webhook URL',
  metaData: 'Meta data',
  showModifiedOn: 'Show Modified On',
  cantDelete: 'Can\'t delete resource. Select Force flag and try again to force delete this resource!',
  connectedResources: 'Resources connected to this resource',
  roleId: 'Role ID',
  showId: 'Show ID',
  swagger: 'Swagger',
  showComments: 'Comments',
  show: 'Show',
  connectedUsers: 'Users connected to this resource',
  noConnectedResources: 'No resources connected to this resource',
  lastLogin: 'Last login',
  logsErrTtlInMSec: 'Time-to-live for error logs',
  includesAnotherValidation: 'Includes validations',
  advancedOptions: 'Advanced options',
  customFunctions: 'Flowy functions',
  values: 'Values',
  value: 'Value',
  condition: 'Condition',
  regex: 'Regex',
  queryName: 'Query name',
  result: 'Result',
  inputMatchesRegex: 'Input matches regex',
  queryConditions: 'Query conditions',
  exchange: 'Exchange',
  virtualHost: 'Virtual host',
  routingKey: 'Routing key',
  resourceType: 'Resource type',
  entries: 'Entries',
  expression: 'Expression',
  sourceObject: 'Source object',
  targetText: 'Target text',
  targetMetadata: 'Target metadata',
  sourceObjects: 'Source objects',
  baseObject: 'Base object',
  compareObject: 'Compare object',
  retryOnCodes: 'Retry on codes',
  role: 'Role',
  toChange: 'To change',
  thisWillOverwrite: 'This will overwrite selected resources',
  toggle: 'Toggle',
  processValidation: 'Process validation',
  propertyAction: 'Property / Action',
  projection: 'Projection',
  useSslProtocol: 'Use SSL protocol',
  converts: 'Converts',
  library: 'Library',
  libraries: 'Libraries',
  import: 'Import',
  parentProcess: 'Parent process',
  parentEvent: 'Parent event',
  expiresIn: 'Expires in (sec)',
  showFinishedOn: 'Show Finished On',
  processDebugger: 'Process debugger',
  showStepType: 'Show Step Type',
  showVisualId: 'Show Visual ID',
  senderAddress: 'Sender email address',
  admin: 'Admin',
  passwordChange: 'Password change',
  oldPassword: 'Old password',
  newPassword: 'New password',
  serviceDesk: 'Service Desk',
  pattern: 'Pattern',
  payableAmount: 'Payable Amount',
  paymentMeans: 'Payment Means',
  paymentMeansCode: 'Payment Means Code',
  groupingSeparator: 'Grouping separator',
  decimalSeparator: 'Decimal separator',
  clientKey: 'Client Key (PEM)',
  xml: 'XML',
  xslt: 'XSLT',
  python: 'Python',
  maxEmailSendingThreads: 'Max. email sending threads',
  searchResources: 'Search resources',
  noResultsFound: 'No results found',
  addedResources: 'Added resources',
  noResourcesAdded: 'No resources added',
  thisWillAdd: 'This will add additional values to the existing ones',
  thisWillRemove: 'This will remove values from the existing ones if they exist',
  emails: 'Emails',
  database: 'Database',
  statistics: 'Statistics',
  filterByProcess: 'Filter by process',
  eventCreatedOn: 'Event created on',
  eventModifiedOn: 'Event modified on',
  retriggerEvent: 'Retrigger event',
  eventTriggered: 'The event has been triggered',
  finished: 'Finished',
  scheme: 'Scheme',
  schema: 'Schema',
  script: 'Script',
  retained: 'Retained',
  qos: 'QoS',
  duration: 'Duration',
  avgDuration: 'Avg',
  totalDuration: 'Total',
  minDuration: 'Min Duration',
  maxDuration: 'Max Duration',
  allSessionsDeleted: 'All sessions deleted',
  expireOn: 'Expire on',
  responseCode: 'Response code',
  qraphQlResponseContentTargetObject: 'GraphQL response content target object',
  rssResponseContentTargetObject: 'RSS response content target object',
  diagram: 'Diagram',
  debugger: 'Debugger',
  optimizer: 'Optimizer',
  listenAllProcesses: 'Listen all processes',
  listenProcess: 'Listen process',
  listenStatus: 'Listen status',
  listenType: 'Listen type',
  listenProcessId: 'Listen process ID',
  showListenAllProcesses: 'Only listening to all processes',
  searchType: 'Search type',
  unitCode: 'Unit Code',
  unique: 'Unique',
  relation: 'Relation',
  entityRequest: 'Entity request',
  entity: 'Entity',
  entityType: 'Entity type',
  customEntity: 'Custom entity',
  generateEntity: 'Generate entity',
  existingPersistenceName: 'Existing persistence name',
  deletePersistence: 'Delete persistence',
  deleteResources: 'Delete resources',
  primaryKey: 'Primary key',
  relations: 'Relations',
  persistence: 'Persistence',
  errorHandler: 'Error handler',
  errorHandleProcess: 'Error handle process',
  translations: 'Translations',
  resourceAction: 'Resource action',
  resources: 'Resources',
  resourceId: 'Resource ID',
  conflict: 'Conflict',
  foreignKey: 'Foreign key',
  generation: 'Generation',
  rootCertificate: 'Root certificate',
  rootCertificatePassword: 'Root certificate password',
  clientCertificate: 'Client certificate',
  clientPrivateKey: 'Client private key',
  instances: 'Instances',
  versionEntity: 'Version Entity',
  versionPersistence: 'Version Persistence',
  generated: 'Generated',
  existing: 'Existing',
  deletedResources: 'Deleted resources',
  nonExistent: 'Non-existent',
  parentRelations: 'Parent relations',
  childRelations: 'Child relations',
  activeIn: 'Active in',
  allSteps: 'All steps',
  changeInAllSteps: 'Change in all steps',
  massModifyAllSteps: 'Mass modify all steps',
  twoFaAuth: 'Two-factor auth',
  enabledTwoFaAuth: 'Two-factor authentication enabled',
  disabledTwoFaAuth: 'Two-factor authentication disabled',
  scanQrCode: 'Scan QR code using your authenticator app',
  enterQrCode: "Please enter the code displayed in the authenticator app here to turn 2FA on.",
  otp: 'One-time password',
  otpShort: 'OTP',
  submitOtp: 'Submit OTP to activate',
  disable: 'Disable',
  twoFaAuthentication: 'Two-factor authentication',
  activeTriggers: 'There are still triggers calling this process. Would you like to deactivate these too?',
  reloadData: 'Reload data',
  memory: 'Memory',
  cpu: 'CPU',
  executionsSumUp: 'Executions sum up',
  instanceHeartbeatInMSec: 'Instance heartbeat',
  syncSettingsDelayInMSec: 'Sync settings delay',
  systemSchedulerPoolSize: 'System scheduler pool size',
  userRegisterTokenTtlInMSec: 'User register token TTL',
  inactiveTtlInMSec: 'Inactive TTL',
  syncDelayInMSec: 'Sync delay',
  cleanUpDelayInMSec: 'Clean up delay',
  heartbeatInMSec: 'Heartbeat',
  timeoutInMSec: 'Timeout',
  mfaStartingDate: 'MFA starting date',
  afterMfaStartingdateYouWontBeAbleToLogin: 'Soon you won\'t be able to log in without MFA enabled. Please enable MFA in settings.',
  cleanUpErrorsDelayInMSec: 'Clean up errors delay',
  cleanUpLogsDelayInMSec: 'Clean up logs delay',
  executeProcessStepChildEventDelayInMSec: 'Execute process step child event delay',
  fetchEventsDelayInMSec: 'Fetch events delay',
  fetchedTtlInMSec: 'Fetched TTL',
  fixExecutionStateDelayInMSec: 'Fix execution state delay',
  eventsCount: 'Events count',
  handleDelayInMSec: 'Handle delay',
  prometheusMetricsWhitelist: 'Prometheus metrics whitelist',
  waitEventTimeInMSec: 'Wait event time',
  ttlInMSec: 'TTL',
  cleanDelayInMSec: 'Clean delay',
  cleanEnabled: 'Clean enabled',
  internalJobsDelayInMSec: 'Internal jobs delay',
  moduleVersion: 'Module version',
  monetaryTotals: 'Monetary Totals',
  filterRoles: 'Filter roles',
  encoding: 'Encoding',
  sourceEncoding: 'Source encoding',
  targetEncoding: 'Target encoding',
  selectRelationsLevel: 'Relations level',
  defaultValue: 'Default value',
  cantSetDefaultValueIfRequired: 'Can\'t set if field is required',
  ipAddresses: 'IP address(es)',
  searchMatchingPattern: 'Search matching pattern',
  inputValidation: 'Input validation',
  outputValidation: 'Output validation',
  cantSetIfFieldNoVarcharAndSearchable: 'Can\'t set if field is not varchar and searchable',
  authType: 'Auth type',
  cantSetIfFieldIsNoSearchable: 'Can\'t set if field is not searchable',
  isSftp: 'Secure FTP',
  triggerName: 'Trigger name',
  isSystem: 'System',
  report: 'Report',
  existingObjects: 'Existing objects',
  newObjects: 'New objects',
  missingResources: 'Missing resources',
  conflicts: 'Conflicts',
  exists: 'Exists',
  missing: 'Missing',
  affectedTriggers: 'Affected triggers by name change',
  nameWasChanged: 'Name was changed',
  includeSystem: 'Include System',
  XML: 'XML',
  enableDebugLog: 'Debug',
  isDebugLogEnabled: 'Debug',
  uploadCertificate: 'Upload certificate',
  useCacheVariable: 'Use Cache Variable',
  persistenceUpdate: 'Persistence update',
  persistenceNew: 'Persistence new',
  skip: 'Skip',
  limit: 'Limit',
  environmentName: 'Environment name',
  sortable: 'Sortable',
  sortField: 'Sort field',
  sortDirection: 'Sort direction',
  stopExecution: 'Stop execution',
  areYouSureExecutionStop: 'Are you sure you want to stop the execution?',
  refreshStatistics: 'Refresh statistics',
  shouldFinishBy: 'Should finish by',
  estimatedTimeOfExecution: 'Max Execution Time',
  actualTimeOfExecution: 'Actual Execution Time',
  OCR: 'OCR',
  QR: 'QR',
  image: 'Image',
  size: 'Size',
  range: 'range',
  messages: 'Messages',
  cleanUpBatchSize: 'Clean up batch size',
  staticLanguage: 'Static language',
  lastHeartbeatBefore: 'Since Last Heartbeat',
  userDn: 'User DN',
  baseDn: 'Base DN',
  certificate: 'Certificate',
  isSshKey: 'SSH Key Credential',
  dn: 'DN',
  objectClassAttributes: 'Object class attributes',
  attributeValues: 'Attribute values',
  searchKey: 'Search key',
  errorCorrectionLevel: 'Error correction level',
  organizer: 'Organizer',
  summary: 'Summary',
  startTime: 'Start time',
  endTime: 'End time',
  participants: 'Participants',
  alarm: 'Alarm',
  alarmTime: 'Alarm time',
  alarmDescription: 'Alarm description',
  recurrence: 'Recurrence',
  frequency: 'Frequency',
  frequencyInterval: 'Frequency interval',
  location: 'Location',
  stepLogs: 'Step Logs',
  static: 'Static',
  dynamic: 'Dynamic',
  optional: 'Optional',
  allowedLoginAttempts: 'Allowed login attempts',
  allowedApiAttempts: 'Allowed API attempts',
  failedLoginAttempts: 'Failed login attempts',
  failedApiAttempts: 'Failed API attempts',
  lastSuccessfulLogin: 'Last successful login',
  resetFailedLoginAttempts: 'Reset failed login attempts',
  tenant: 'Tenant',
  filename: 'Filename',
  file: 'File',
  issueKey: 'Issue key',
  transitionId: 'Transition ID',
  expand: 'Expand',
  projectKey: 'Project key',
  issueType: 'Issue type',
  itemName: 'Item Name',
  reporter: 'Reporter',
  assignee: 'Assignee',
  components: 'Components',
  labels: 'Labels',
  MCP_CredType: 'MCP Credential Type',
  addInvoiceLine: 'Add Invoice Line',
  addLabels: 'Add labels',
  removeLabels: 'Remove labels',
  jql: 'JQL',
  nextPageToken: 'Next page token',
  parent: 'Parent',
  openProcess: 'Open process',
  CLOUD_FRONT: 'CloudFront',
  domainName: 'Domain name',
  domainId: 'Domain ID',
  distributionId: 'Distribution ID',
  distributionComment: 'Distribution comment',
  calendarId: 'Calendar ID',
  reminderMinutesBeforeStart: 'Reminder: minutes before start',
  reminderRecurrencePattern: 'Recurrence pattern',
  reminderRecurrenceInterval: 'Recurrence interval',
  reminderDaysOfWeek: 'Days of week',
  reminderRecurrenceRangeStart: 'Recurrence range start',
  reminderRecurrenceRangeEnd: 'Recurrence range end',
  attendees: 'Attendees',
  addVariable: 'Add variable',
  addTranslation: 'Add translation',
  addTaxSubtotal: 'Add Tax Subtotal',
  addTemplate: 'Add template',
  addStaticResource: 'Add static resource',
  cantSetDefaultValueIfPrimaryOrUnique: 'Can\'t set if field is primary or unique',
  bic: 'BIC',
  binary: 'Binary',
  settingsAppliedSystemGenerated: 'Settings applied for system and generated resources',

  withFlowy: '#WithFlowy',

  homeHeaderFirst: 'Empower your workflow',
  homeHeaderSecond: 'Streamline your processes',
  homeHeaderThird: 'Achieve seamless integration',

  homeFeatureFirst1: 'Automate processes with pre-built blocks.',
  homeFeatureFirst2: 'Extract data from multiple sources seamlessly.',
  homeFeatureFirst3: 'Ensure reliable data flow with load handling.',
  homeFeatureFirst4: 'Integrate with APIs effortlessly.',

  homeFeatureSecond1: 'Real-time insights with dashboards.',
  homeFeatureSecond2: 'Scale your infrastructure with ease.',
  homeFeatureSecond3: 'Comprehensive reporting tools.',
  homeFeatureSecond4: 'Secure data management solutions.',

  homeFeatureThird1: 'Simplify complex workflows.',
  homeFeatureThird2: 'Enhanced team collaboration.',
  homeFeatureThird3: 'Built-in error handling.',
  homeFeatureThird4: 'Customizable integrations.',

  settingsAppliedGenerated: 'Settings applied for generated resources',
  version: 'Version',
  processVersion: 'Process version',
  historicalVersionShownWarning: 'The selected event references to an historic version of the process. The according version is being displayed. Please take precautions.',
  versionOfEventDoesntExistWarning: 'The selected event references to an historic version of the process which is no longer available. Hence the current version is displayed below.',
  encodingRemoteServer: 'Encoding of the Response of the remote server',
  imageQuality: 'Image quality',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  veryHigh: 'Very high',
  increased: 'Increased',
  max: 'Max',
  hazelcastMember: 'Hazelcast member',
  fileExtension: 'File extension',
  picture: 'Picture',
  staticResourceContainsFile: 'Static resource contains file',

  otherUsersEditThisResource: 'Other users are editing this resource',
  areYouSureSubmit: 'Are you sure you want to submit?',
  visibleOnDatabrowser: 'Show on browse',
  timezone: 'Timezone',
  SET_VARIABLES: 'Set variables',
  dbSize: 'Database Size',
  refreshInputOutput: 'Refresh Input/Output',
  quickFilter: 'Quick filter',
  lastWeek: 'Last week',
  currentWeek: 'Current week',
  lastMonth: 'Last month',
  currentMonth: 'Current month',
  yesterday: 'Yesterday',
  today: 'Today',
  revision: 'Revision',
  nullIfNotExists: 'Return null if file does not exist',
  flushCacheTitle: 'Flush cache',
  maxTokens: 'Max tokens',
  temperature: 'Temperature',
  topP: 'Top P',
  frequencyPenalty: 'Frequency penalty',
  presencePenalty: 'Presence penalty',
  autoGenerated: 'Auto generated',
  autoPauseTimeout: 'Auto Pause Timeout',
  includeGenerated: 'Include Generated',
  retryAfterMs: 'Retry after',
  retryAttempts: 'Retry attempts',
  searchByType: 'Search by type',
  operation: 'Operation',
  baseTime: 'Base time',
  compareTime: 'Compare time',
  instanceCleanCleanDelayInMSec: 'Instance Clean Delay',
  accountId: 'Account ID',
  createUserIfNotExists: 'Create user if not exists',
  strictMode: 'Strict mode',
  instanceStatisticsRetentionPeriod: 'Instance Statistics Retention Period',
  instanceStatistic: 'Instance Statistic',
  childProcessComment: 'Child process comment',
  childFlowComment: 'Child flow comment',
  roundingType: 'Rounding type',
  tools: 'Tools',
  triggerLogFaultyRequest: 'Trigger log faulty request',
  processCacheStepLogs: 'Process cache step',
  toolName: 'Tool name',
  commandResult: 'Command Result',
  commandStateCompleted: 'Completed',
  commandStateFailed: 'Failed',
  commandStateTimedOut: 'Timed out',
  commandStateRunning: 'Running',
  commandStatePending: 'Pending',
  stdout: 'STDOUT',
  stderr: 'STDERR',
  state: 'State',
  commandUse: 'Command Use',
  commandUseId: 'Command Use ID',
  rawBlock: 'Raw Data',
  rawSourceType: 'Source Type',
  rawData: 'Data',
  map: 'Map',
  cacheVariable: 'Cache variable',
  pollingIntervalMs: 'Polling interval MS',
  timeoutMs: 'Timeout MS',
  childEventIds: 'Child event IDs',
  tenantId: 'Tenant ID',
  batch: 'Batch',
  priceAmount: 'Price Amount',
  primaryRole: 'Primary role',
  balanceTransactionId: 'Balance transaction ID',
  paymentIntentId: 'Payment Intent ID',
  cancellationReason: 'Cancellation reason',
  paymentMethod: 'Payment Method',
  chargeId: 'Charge ID',
  receiptEmail: 'Receipt email',
  reason: 'Reason',
  confirmationMethod: 'Confirmation method',
  paymentMethodId: 'Payment method ID',
  refundId: 'Refund ID',
  productId: 'Product ID',
  payoutId: 'Payout ID',
  disputeId: 'Dispute ID',
  inactiveTtl: 'Inactive TTL',
  cursor: 'Cursor',
  messagesPerPage: 'Messages per page',
  numberOfPages: 'Number of pages',
  oldestTimestamp: 'Oldest timestamp',
  importProgress: 'Import Progress',
  resourceName: 'Resource name',
  resourceRoles: 'Resource roles',
  totalResources: 'Total resources',
  importedResources: 'Imported resources',
  preciseName: 'Precise name',
  mcpServerCredentials: 'MCP server credentials',
  systemDataRoles: 'System Data roles',
  systemMessage: 'System message',
  timeSpentSeconds: 'Time spent seconds',
  aiAgent: 'AI Agent',
  databaseUrl: 'Database URL',
  databaseUsername: 'Database Username',
  databasePassword: 'Database Password',
  harborToken: 'Harbor Token',
  showContainers: 'Containers',
  harborContainers: 'Containers',
  cacheValues: 'Cache Values',
  staticResource: 'Static Resource',
  css: 'CSS',
  provider: 'Provider',
  graphBaseUrl: 'Graph Base URL',
  phoneNumberId: 'Phone Number ID',
  phoneNumberBaseUrl: 'Phone Number Base URL',
  visibleOnLogin: 'Visible on login',
  elementId: 'Element ID',
  debounceInMillis: 'Debounce (ms)',
  direction: 'Direction',
  screens: 'Screens',
  flow: 'Flow',
  flows: 'Flows',
  flowName: 'Flow Name',
  flowLogsEnabled: 'Logging',
  stepsJson: 'Steps (JSON)',
  copied: 'Copied!',
  copyKey: 'Copy key',
  copyValue: 'Copy value',
  copyResult: 'Copy Result',
  copyExecution: 'Copy Execution',
  toBeAdded: 'To Be Added',
  rowsPerPage: 'Rows per page:',
  added: 'Added',
  users: 'Users',
  tenantUsers: 'Tenant Users',
  createTenantUser: 'Create Tenant User',
  docs: 'Docs',
  webhookPath: 'Webhook Path',
  mcpServers: 'MCP Servers',
  allowedTools: 'Allowed Tools',
  requireApproval: 'Require Approval',
  builtinTool: 'Built-in tool',
  advisorModel: 'Advisor model',
  browse: 'Browse',
  structure: 'Structure',
  data: 'Data',
  indexes: 'Indexes',
  nullable: 'Nullable',
  autoIncrement: 'Auto Increment',
  columns: 'Columns',
  selectTableToViewDetails: 'Select a table to view its details',
  noColumnsFound: 'No columns found',
  noDataFound: 'No data found',
  noIndexesFound: 'No indexes found',
  tables: 'Tables',
  sequences: 'Sequences',
  lastValue: 'Last Value',
  selectSequenceToViewDetails: 'Select a sequence to view its details',
  buyerReference: 'Buyer Reference',
  cityName: 'City Name',
  companyId: 'Company ID',
  companyIdSchemeId: 'Company ID Scheme ID',
  countryCode: 'Country Code',
  countrySubentity: 'Country Subentity',
  customerAddress: 'Customer Address',
  customerParty: 'Customer Party',
  customizationId: 'Customization ID',
  documentCurrencyCode: 'Document Currency Code',
  dueDate: 'Due Date',
  endpointId: 'Endpoint ID',
  endpointSchemeId: 'Endpoint Scheme ID',
  invoiceId: 'Invoice ID',
  invoiceLine: 'Invoice Line',
  invoiceLines: 'Invoice Lines',
  issueDate: 'Issue Date',
  note: 'Note',
  postalZone: 'Postal Zone',
  profileId: 'Profile ID',
  registrationName: 'Registration Name',
  streetName: 'Street Name',
  supplierAddress: 'Supplier Address',
  supplierParty: 'Supplier Party',
  taxAmount: 'Tax Amount',
  taxCategoryId: 'Tax Category ID',
  taxExclusiveAmount: 'Tax Exclusive Amount',
  taxId: 'Tax ID',
  taxInclusiveAmount: 'Tax Inclusive Amount',
  taxPercent: 'Tax Percent',
  taxSubtotal: 'Tax Subtotal',
  taxSubtotals: 'Tax Subtotals',
  taxableAmount: 'Taxable Amount',
  deploymentCredentialName: 'Deployment Credential Name',
  cdnCredentialName: 'CDN Credential Name',
  cdnRefreshStatus: 'CDN Refresh Status',
  triggeredOn: 'Triggered On',
  errorDetails: 'Error Details',
  operationType: "Operation Type",
  deploymentStage: "Deployment Stage",
  applicationType: 'Application Type',
  applicationName: 'Application Name',
  containerRuntime: 'Container Runtime',
  containerIp: 'Container IP',
  allowedCommandList: 'Allowed Commands',
  buildCommandList: 'Build Commands',
  defaultToolList: 'Default Tools',
  buildPath: 'Build Path',
  workingDirectory: 'Working Directory',
  buildImage: 'Build Image',
  allowedPorts: 'Allowed Ports',
  internetAccess: 'Internet Access',
  networks: 'Networks',
  autoStart: 'Automatic Start',
  enableFlowyMcpEndpoints: 'Enable MCP Endpoints',
  runCommandList: 'Run Commands',
  stopCommandList: 'Stop Commands',
  containerEntryPoint: 'Entry Point',
  containerCommands: 'Commands',
  deploymentPath: 'Deployment Path',
  container: 'Container',
  files: 'Files',
  git: 'Git',
  branch: 'Branch',
  noBranchesAvailable: 'No branches available',
  workingCopy: 'Working copy',
  lastCommandOutput: 'Last command output',
  exitCode: 'Exit code',
  outputPanelEmpty: 'No command output yet',
  gitCredentialName: 'GIT Credential Name',
  gitBranch: 'Git Branch',
  repositoryUrl: 'Repository URL',
  gitHelperImage: 'Git Helper Image',
  runtime: 'Runtime',
  networking: 'Networking',
  sourceControl: 'Source Control',
  execution: 'Execution',
  selectEventForOptimizer: 'Select an event to view performance data',
  millisecondsShort: 'ms',
  optimizerLoadError: 'Could not load performance data',
  optimizerPartialResults: 'Some data could not be loaded. Showing partial results.',
  application: 'Application',
  linkedResources: 'Linked Resource',
  you: 'You',
  assistant: 'Assistant',
  dockerRuntimeImages: 'Docker Runtime Images',
  reconcileDelayInMSec: 'Reconcile Delay',
  maxFileSizeInBytes: 'Max File Size',
  maxStdoutLength: 'Max Stdout Length (characters)',
  maxStderrLength: 'Max Stderr Length (characters)',
  minimumDuration1000Ms: 'Minimum value is 1000 ms',
  uploadFile: 'Upload File',
  downloadFile: 'Download File',
  viewFile: 'View File',
  deleteFile: 'Delete File',
  defaultScreenName: 'Default Screen Name',
  noMatchingScreens: 'No screens match application tags',
  msec: 'Milliseconds',
  sec: 'Seconds',
  min: 'Minutes',
  hr: 'Hours',
  day: 'Days',
  bytes: 'Bytes',
  kilobytes: 'Kilobytes',
  megabytes: 'Megabytes',
  gigabytes: 'Gigabytes',
  wsdlUrl: 'WSDL URL',
  soapAction: 'SOAP Action',
  soapVersion: 'SOAP Version',
  soapVersion11: 'SOAP 1.1',
  soapVersion12: 'SOAP 1.2',
  wsSecurityType: 'WS-Security Type',
  wsSecurityTypeNone: 'None',
  wsSecurityTypeUsernameToken: 'Username Token',
  wsSecurityTypeTimestamp: 'Timestamp',
  namespaces: 'Namespaces',
  skills: 'Skills',
  noSkillsAttached: 'No skills attached to this credential',
  attachSkill: 'Attach skill',
  processDelayInMSec: 'Process Delay In MSec',
  refreshSkillsResultTitle: 'Refresh result',
  refreshSkillsUpdated: 'Updated credentials',
  refreshSkillsFailed: 'Failed credentials',
  refreshSkillsNone: '(none)',
  uploadDeployment: 'Upload deployment',
  stage: 'Stage',
  triggered: 'Triggered'
}
